<template>
  <div class="">
    <v-app-bar app class="primary elevation-3">
      <div class="d-flex flex-grow-1 align-center px-xl-16">
        <v-btn
          icon
          v-if="$vuetify.breakpoint.smAndDown"
          @click="drawer = !drawer"
        >
          <v-icon color="white">mdi-menu</v-icon>
        </v-btn>

        <template v-else class="d-flex">
          <div
            v-if="userRole == 'credit'"
            class="white--text text-h6 font-weight-regula app-title"
            @click="$router.push('/employees')"
          >
            Πλατφόρμα Αμοιβαιών Κεφαλαίων Χρηματαγοράς
          </div>

          <div
            v-else-if="userRole == 'admin'"
            class="white--text text-h6 font-weight-regula app-title"
            @click="$router.push('/admin/periods')"
          >
            Πλατφόρμα Αμοιβαιών Κεφαλαίων Χρηματαγοράς
          </div>

          <div
            v-else-if="userRole == 'hcmc' || userRole == 'viewer'"
            class="white--text text-h6 font-weight-regula app-title"
            @click="$router.push('hcmc')"
          >
            Πλατφόρμα Αμοιβαιών Κεφαλαίων Χρηματαγοράς
          </div>

          <div v-if="userRole == 'credit'" class="ml-auto d-flex align-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on" icon>
                  <v-icon size="25" color="white">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item-group color="primary">
                  <v-list-item color="primary" to="/profile">
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>Προφίλ</v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="onLogout" color="primary">
                    <v-list-item-icon>
                      <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>Έξοδος</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>

          <div v-else-if="userRole == 'admin'" class="ml-auto">
            <v-btn
              class="white--text elevation-0 text-body-1 font-weight-regular"
              text
              @click="onLogout"
            >
              <div class="d-flex align-center">
                <v-icon color="white">mdi-logout</v-icon>
                <span class="ml-1">Έξοδος</span>
              </div>
            </v-btn>
          </div>

          <div
            v-else-if="userRole == 'hcmc' || userRole == 'viewer'"
            class="ml-auto d-flex align-center"
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on" icon>
                  <v-icon size="25" color="white">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item-group color="primary">
                  <v-list-item color="primary" to="/profile">
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>Προφίλ</v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="onLogout" color="primary">
                    <v-list-item-icon>
                      <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>Έξοδος</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </template>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-if="userRole == 'credit'"
      class="primary"
      app
      disable-resize-watcher
      v-model="drawer"
    >
      <div class="d-flex flex-column pt-5">
        <v-btn text class="mb-2 white--text flex-grow-1" to="/employees">
          <div class="d-flex align-center mr-auto">
            <v-icon color="white">mdi-home</v-icon>
            <span class="ml-1">Αρχική</span>
          </div>
        </v-btn>

        <v-btn
          text
          @click="onNewReport"
          to="/employees/new/report"
          class="mb-2 white--text"
        >
          <div class="d-flex align-center mr-auto">
            <v-icon color="white">mdi-plus-box</v-icon>
            <span class="ml-1">Νέα Έκθεση</span>
          </div>
        </v-btn>

        <v-btn text class="white--text" @click="onLogout">
          <div class="d-flex align-center mr-auto">
            <v-icon color="white">mdi-logout</v-icon>
            <span class="ml-1">Έξοδος</span>
          </div>
        </v-btn>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-else-if="userRole == 'admin'"
      class="primary"
      app
      disable-resize-watcher
      v-model="drawer"
    >
      <div class="d-flex flex-column pt-5">
        <v-btn text class="mb-2 white--text flex-grow-1" to="/admin/periods">
          <div class="d-flex align-center mr-auto">
            <v-icon color="white">mdi-home</v-icon>
            <span class="ml-1">Αρχική</span>
          </div>
        </v-btn>

        <v-btn text class="white--text" @click="onLogout">
          <div class="d-flex align-center mr-auto">
            <v-icon color="white">mdi-logout</v-icon>
            <span class="ml-1">Έξοδος</span>
          </div>
        </v-btn>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-else-if="userRole == 'hcmc' || userRole == 'viewer'"
      class="primary"
      app
      disable-resize-watcher
      v-model="drawer"
    >
      <div class="d-flex flex-column pt-5">
        <v-btn text class="mb-2 white--text flex-grow-1" to="hcmc">
          <div class="d-flex align-center mr-auto">
            <v-icon color="white">mdi-home</v-icon>
            <span class="ml-1">Αρχική</span>
          </div>
        </v-btn>

        <v-btn text class="white--text" @click="onLogout">
          <div class="d-flex align-center mr-auto">
            <v-icon color="white">mdi-logout</v-icon>
            <span class="ml-1">Έξοδος</span>
          </div>
        </v-btn>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      drawer: false,
    };
  },

  computed: {
    ...mapState({
      userRole: (state) => state.auth.userRole,
      fullName: (state) => state.auth.fullName,
    }),
  },

  methods: {
    ...mapMutations(["setCurrentRoute"]),
    ...mapActions(["logout"]),

    onNewReport() {
      this.setCurrentRoute("new");
      this.$router.push("/employees/new/report");
    },

    onLogout() {
      this.logout().then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style scoped lang="scss">
.app-title:hover {
  cursor: pointer;
}
</style>
